<template>
  <div>
    <wty-UserGroup :who="'merchant'"></wty-UserGroup>
  </div>
</template>
<script>
import wtyUserGroup from "@/components/wty-userGroup.vue";
export default {
  name: "musergroup",
  data() {
    return {};
  },
  components: { wtyUserGroup }
};
</script>

<style lang="less" scoped>
.el-card {
  margin: 0px;
}
</style>
